import { IsRole } from './validator.js';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from '@mui/material';
import { Component } from 'react';
import { Button, Form, Modal, Stack } from 'react-bootstrap';
import { Api } from './interface.js';
import { ROWSPERPAGE } from './constants.js';
import { toast } from 'react-toastify';
import { getComparator, handleResize, bake } from './common.js';
import NoAccess from './noAccess.js';
import React from 'react';
import bcrypt from 'bcryptjs-react';

class Logins extends Component {
  constructor(props) {
    super(props);
    this.tableCellHover = [
      {
        '&:hover': {
          backgroundColor: '#BDBDBD',
        },
      },
    ];

    this.passwordTextObfusticated = '********';

    this.columns = [
      {
        key: 'username',
        label: 'Username',
      },
      {
        key: 'password',
        label: 'Password',
      },
    ];

    this.state = {
      rowsPerPage: bake({ props: props, key: 'rowsPerPage' })
        ? Number(bake({ props: props, key: 'rowsPerPage' }))
        : 15,
      searchText: bake({ props: props, key: 'searchText' }) ?? '',
      logins: [],
      filteredRows: [],
      page: 0,
      order: 1,
      orderBy: '',
      maxRows: 15,
      editingLogin: null,
      newPassword: null,
      username: null,
      password: null,
      buttonsDisabled: false,
    };
  }

  componentDidMount = () => {
    this.getLogins();
  };

  componentDidUpdate() {
    handleResize();
  }

  closeModal = () => {
    this.setState({
      currentModal: null,
      editingLogin: null,
      newPassword: null,
    });
  };

  getLogins = () => {
    Api({
      sp: 'getLogins',
      json: {},
    }).then((response) => {
      this.setState({
        logins: response,
        filteredRows: this.filterLogins(response, this.state.searchText),
      });
      handleResize();
    });
  };

  temporarilyDisableButtons = () => {
    // disable the buttons on click
    this.setState({ buttonsDisabled: true });
    setTimeout(() => {
      this.setState({ buttonsDisabled: false });
    }, 3000);
  };

  createLogin = () => {
    this.temporarilyDisableButtons();
    if (this.state.password == null) {
      toast.error('Password is required');
      return;
    }

    if (this.state.username == null) {
      toast.error('Username is required');
      return;
    }

    const username = this.state.username;
    const hash = bcrypt.hashSync(this.state.password, 10);

    Api({
      sp: 'addLogin',
      json: { username: username, hash: hash },
    }).then(() => {
      this.setState({
        users: [],
        logins: [],
        filteredRows: [],
        currentModal: null,
        username: null,
        password: null,
      });
      this.getLogins();
      toast.success(this.state.username + ' created successfully');
    });
  };

  updateLogin = () => {
    this.temporarilyDisableButtons();
    if (this.state.newPassword == null) {
      toast.error('Password is required');
      return;
    }

    const hash = bcrypt.hashSync(this.state.newPassword, 10);
    Api({
      sp: 'updateLogin',
      json: { username: this.state.editingLogin, hash: hash },
    }).then(() => {
      this.setState({
        users: [],
        logins: [],
        filteredRows: [],
        currentModal: null,
        username: null,
        password: null,
        newPassword: null,
        editingLogin: null,
      });
      this.getLogins();
      toast.success(this.state.editingLogin + ' updated successfully');
    });
  };

  filterLogins = (rows, searchText) => {
    const searchFilter = (row) => {
      const username = row['username'];
      if (username == null) {
        return false;
      }
      return username.toLowerCase().includes(searchText.toLowerCase());
    };
    return rows.filter(searchFilter);
  };

  validateLoginPassword = (password) => {
    if (password == null) {
      return false;
    }

    if (password.length < 8) {
      return false;
    }

    return true;
  };

  onSearchTextChange = (searchText) => {
    bake({ props: this.props, key: 'searchText', value: searchText });
    this.setState({
      searchText: searchText,
      filteredRows: this.filterLogins(this.state.logins, searchText),
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    // Save selected rows per page to cookies
    bake({
      key: 'rowsPerPage',
      value: parseInt(event.target.value, 10),
    });

    this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
  };

  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({ order: isAsc ? 'desc' : 'asc', orderBy: property });
  };

  render = () => {
    if (!IsRole(['Admin', 'Dev'], this.props.roles)) {
      return <NoAccess />;
    }

    const tableHeader = (
      <TableHead>
        <TableRow>
          <TableCell
            key="username"
            sortDirection={
              this.state.orderBy === 'username' ? this.state.order : false
            }
            className="table-header"
          >
            <span>Username</span>
            <TableSortLabel
              active={this.state.orderBy === 'username'}
              direction={
                this.state.orderBy === 'username' ? this.state.order : 'asc'
              }
              onClick={(e) => this.handleRequestSort(e, 'username')}
            ></TableSortLabel>
          </TableCell>

          <TableCell key="password" className="table-header">
            <span>Password</span>
          </TableCell>
        </TableRow>
      </TableHead>
    );

    return (
      <div className="main-container mt-2">
        {/* Page Title */}
        <div className="mt-2 d-flex justify-content-between">
          <h2>Logins</h2>
          <Button
            className="addEntity mb-2"
            variant="primary"
            onClick={() => this.setState({ currentModal: 'AddLogin' })}
          >
            Add Login
          </Button>
        </div>

        <Stack className="pb-2" direction="horizontal" gap={3}>
          {/* Search Bar */}
          <Form.Control
            value={this.state.searchText}
            type="text"
            placeholder="Search"
            onChange={(e) => this.onSearchTextChange(e.target.value)}
            autoFocus
          />
        </Stack>

        {/* Material Table */}
        <Paper sx={{ width: '100%' }}>
          <TableContainer
            id="tab-container"
            component={Paper}
            className="tableContainer"
            style={{
              maxHeight: this.state.maxRows * 53 + 57,
            }}
          >
            <Table stickyHeader aria-label="sticky table">
              {/* Column Headers */}
              {tableHeader}

              {/* Table Content */}
              <TableBody>
                {this.state.filteredRows
                  .slice()
                  .sort(getComparator(this.state.order, this.state.orderBy))
                  .slice(
                    this.state.page * this.state.rowsPerPage,
                    this.state.page * this.state.rowsPerPage +
                      this.state.rowsPerPage
                  )
                  .map((row, i) => {
                    return (
                      <TableRow
                        className="pointer"
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={i}
                        onClick={() =>
                          this.setState({
                            currentModal: 'UpdateLoginPassword',
                            editingLogin: row['username'],
                          })
                        }
                      >
                        <TableCell key="username">{row['username']}</TableCell>
                        <TableCell key="password">
                          {this.passwordTextObfusticated}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            labelRowsPerPage="Rows:"
            rowsPerPageOptions={ROWSPERPAGE}
            component="div"
            count={this.state.filteredRows.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Paper>

        <Modal
          show={
            this.state.currentModal === 'UpdateLoginPassword' &&
            this.state.editingLogin
          }
          onHide={() => this.closeModal()}
          className="edge-modal"
        >
          <Modal.Header closeButton={true}>
            <Modal.Title>
              Update password for {this.state.editingLogin}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <i>Passwords must be at least 8 characters long.</i>
            </p>
            <Form>
              <Form.Control
                type="password"
                autoComplete="off"
                placeholder="New password"
                onChange={(e) => this.setState({ newPassword: e.target.value })}
              />
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={this.updateLogin}
              disabled={
                this.state.buttonsDisabled ||
                !this.validateLoginPassword(this.state.newPassword)
              }
            >
              Update password
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.currentModal === 'AddLogin'}
          onHide={() => this.closeModal()}
          className="edge-modal"
        >
          <Modal.Header closeButton={true}>
            <Modal.Title>Add Login</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <i>Passwords must be at least 8 characters long.</i>
            </p>
            <Form>
              <Form.Control
                type="text"
                autoComplete="off"
                placeholder="Username"
                onChange={(e) => this.setState({ username: e.target.value })}
                autoFocus
              />
              <br />
              <Form.Control
                type="password"
                autoComplete="off"
                placeholder="Password"
                onChange={(e) => this.setState({ password: e.target.value })}
              />
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={this.createLogin}
              disabled={
                this.state.buttonsDisabled ||
                !(
                  this.state.username &&
                  this.validateLoginPassword(this.state.password)
                )
              }
            >
              Create
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  };
}

export default Logins;
